export function computeSummitSpans(count) {
  if (count <= 0) return [];
  const rows = [];
  let remaining = count;
  const mod = remaining % 3;
  const twos = mod === 0 ? 0 : mod === 1 ? 2 : 1;
  for (let i = 0; i < twos; i++) {
    rows.push(2);
    remaining -= 2;
  }
  while (remaining > 0) {
    rows.push(3);
    remaining -= 3;
  }
  return rows.flatMap((rowSize) => {
    const span = 6 / rowSize;
    return Array(rowSize).fill(span);
  });
}
